const extractYachtAndContactsFromListingData = (entity, data, promotionType = null) => {
  const preFilteredContacts = (data.businessContactComponentContacts || []).filter(
    contactData => promotionType !== 'sponsored' || contactData.isSponsored
  );

  const contacts = preFilteredContacts.map(contactData => ({
    brokerBranchId: contactData.brokerBranchId,
    brokerId: contactData.brokerId,
    brokerName: contactData.brokerName,
    businessContactId: contactData.businessContactId,
    exhibitorId: null,
    image: { ...contactData.image },
    internalUrl: contactData.internalUrl,
    name: contactData.name,
    phone: contactData.phone,
    type: 'broker',
    website: contactData.website
  }));
  if (contacts.length === 0) return null;

  const yachtData = {
    id: entity === 'yacht_for_charter' ? data.yachtForCharterId : data.yachtForSaleId,
    builders: data.publishedBuilderProfiles.map(profileData => profileData.name).join(', '),
    builtOnYear: data.built_on_year,
    currency: (data.currency || {}).code || null,
    entity,
    formattedPrice: data.formattedPrice,
    image: data.image,
    isSponsored: data.formattedState === 'sponsored',
    lengthOverall: `${data.length_overall}m`,
    name: data.name,
    price: entity === 'yacht_for_charter' ? data.weeklyLowRate : data.price,
    primaryCategory: (data.category || {}).name || '',
    promotionType: data.formattedState,
    yachtForCharterId: entity === 'yacht_for_charter' ? data.yachtForCharterId : null,
    yachtForSaleId: entity === 'yacht_for_sale' ? data.yachtForSaleId : null,
    yachtPageId: null
  };

  return { contacts, yachtData };
};

export default extractYachtAndContactsFromListingData;
